var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSectionStepDescriptionBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361.538,
    height: "90.06mm",
    viewBox: "0 0 95.657 90.06",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.239,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.6,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m127.62 131.77-14.348 7.72-52.106-30.083.2-14.464 14.676-8.56 51.69 29.844z",
    fill: "#f4f4f4",
    filter: "url(#a)",
    style: {
      paintOrder: "markers fill stroke"
    },
    transform: "scale(.9467) rotate(-30 -49.503 162.223)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(4.095 22.223) scale(.26458)",
    d: "M57.498 39.836 28.75 89.631l28.748 49.795h226.68l28.748-49.795-28.748-49.795zm1.533 2.654h223.62l27.217 47.141-27.217 47.141H59.031l-27.217-47.14z",
    fill: "#404040",
    style: {
      paintOrder: "markers fill stroke"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionStepDescriptionBackground);
export default __webpack_public_path__ + "static/media/about_section_step_description_background.746c5b8df63b1032616a79a26a8d082c.svg";
export { ForwardRef as ReactComponent };